import { render, staticRenderFns } from "./MigrationList.vue?vue&type=template&id=2bbe1384&scoped=true"
import script from "./MigrationList.vue?vue&type=script&lang=js"
export * from "./MigrationList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bbe1384",
  null
  
)

export default component.exports